export default {
  'ACTIVITY.WHATSAPP.MENU.TITLE': 'WhatsApp活动',
  'ACTIVITY.WHATSAPP.LIST.TITLE': '活动列表',
  'ACTIVITY.WHATSAPP.LIST.CREATE.ACTIVITY': '创建WhatsApp活动',
  'ACTIVITY.WHATSAPP.LIST.DRAFT': '草稿',
  'ACTIVITY.WHATSAPP.LIST.SCHEDULED': '已计划',
  'ACTIVITY.WHATSAPP.LIST.ONGOING': '进行中',
  'ACTIVITY.WHATSAPP.LIST.COMPLETED': '已完成',
  'ACTIVITY.WHATSAPP.LIST.CANCELLED': '已终止',
  'ACTIVITY.WHATSAPP.LIST.PAUSED': '已暂停',
  'ACTIVITY.WHATSAPP.LIST.ERROR': '发送中断',
  'ACTIVITY.WHATSAPP.LIST.ERROR.TIPS':
    '由于账号限制等问题导致发送被中断，请联系SmartLink团队获取支持。',
  'ACTIVITY.WHATSAPP.LIST.NAME': '名称',
  'ACTIVITY.WHATSAPP.LIST.CREATE.NAME': '活动名称',
  'ACTIVITY.WHATSAPP.LIST.STATUS': '状态',
  'ACTIVITY.WHATSAPP.LIST.CREATE_TIME': '创建时间',
  'ACTIVITY.WHATSAPP.LIST.LAST_UPDATE_TIME': '最后更新时间',
  'ACTIVITY.WHATSAPP.LIST.UPDATE_TIME': '数据更新时间',
  'ACTIVITY.WHATSAPP.LIST.OPERATION': '操作',
  'ACTIVITY.WHATSAPP.LIST.CREATE_BY': '创建人',
  'ACTIVITY.WHATSAPP.LIST.START_TIME': '开始时间',
  'ACTIVITY.WHATSAPP.LIST.LAST_UPDATE_BY': '最后更新人',
  'ACTIVITY.WHATSAPP.LIST.RECIPIENTS': '收件人',
  'ACTIVITY.WHATSAPP.LIST.CREATE.ENTER.PLACEHOLDER': '请输入活动名称',
  'ACTIVITY.WHATSAPP.LIST.CREATE.DESC1':
    '几分钟内即可创建并启动WhatsApp活动：选择发送者、接收者、消息模板，并设置发送时间。',
  'ACTIVITY.WHATSAPP.LIST.RESTART': '重启',
  'ACTIVITY.WHATSAPP.LIST.DETAILS': '活动详情',
  'ACTIVITY.WHATSAPP.LIST.VIEW.REPORT': '查看报表',
  // create
  'ACTIVITY.WHATSAPP.CREATE.SENDER': '发件人',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.TIPS': '设置此活动的发件人详细信息',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER': '发送号码',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.SELECT.PLACEHOLDER': '选择你的账户',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.SEARCH.PLACEHOLDER': '搜索',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER.DISPATCH': '请选择发送号码',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER.DISPATCH.TIPS':
    '尚未连接任何账户。若要开始使用，请联系SmartLink代表或发送邮件至',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER.DISPATCH.EMAIL':
    'SmartLink_service@proximabeta.com',
  'ACTIVITY.WHATSAPP.CREATE.CONTENT.DISABLED.TIPS':
    '暂无已审批通过的模板。模板通过Meta官方审批后即可使用，请耐心等待。',
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS': '收件人',
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS.TIPS': '请选择收件人',
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS.STATISTICS':
    '<div class="font-size-14"><b class="color-primary font-size-16 font-poppins">{total}</b><b> WhatsApp订阅用户</b>（订阅用户数量将在活动启动后自动更新）</div>',
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS.NO.SUBSCRIPTION':
    '请注意：此标签暂无WhatsApp订阅用户，无法向未订阅用户发送营销活动。',
  'ACTIVITY.WHATSAPP.CREATE.MESSAGE.TITLE': '消息',
  'ACTIVITY.WHATSAPP.CREATE.MESSAGE.TIPS':
    '可为不同语种的收件人分别配置消息模板',
  'ACTIVITY.WHATSAPP.CREATE.CONTENT.TEMPLATE': '模板',
  'ACTIVITY.WHATSAPP.CREATE.CONTENT.TIPS': '请设置内容',
  'ACTIVITY.WHATSAPP.CREATE.CONTENTS.ONE': '{templateName}（{language}）',
  'ACTIVITY.WHATSAPP.CREATE.CONTENTS.MORE':
    '{templateName}（{language}） 及 {num} 个其他语言模板',
  'ACTIVITY.WHATSAPP.CREATE.SCHEDULE': '递送计划',
  'ACTIVITY.WHATSAPP.CREATE.SCHEDULE.TIPS': '请设置递送计划',
  'ACTIVITY.WHATSAPP.CREATE.DIRECT.RELEASE.ACTIVITY.TIPS1':
    '活动发布后，信息不可修改。',
  'ACTIVITY.WHATSAPP.SENDER.LIMIT.WITH_NUMBER':
    '此号码的消息发送上限为<strong class="color-primary"> {number} / 24小时。</strong>',
  'ACTIVITY.WHATSAPP.SENDER.LIMIT.UNLIMITED':
    '此号码的消息发送量为<strong> 不限数量 / 24小时</strong>。',
  'ACTIVITY.WHATSAPP.SENDER.LIMIT.VIEW_DETAILS':
    '<a class="color-primary  font-poppins" href={url} target="_blank">查看详情</a>',

  // 查看报表
  'ACTIVITY.WHATSAPP.LIST.REPORT.TITLE': 'WhatsApp活动报表',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS': '指标',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.RECIPIENTS': '用户数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.WATING': '排队中',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.SEND': '已发送',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.DELIVERED': '已送达',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.READ': '已读数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.CLICK': '点击数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.UNSUBSCRIBE': '退订数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.REPLY': '回复数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.COUNT': '数值',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE': '比率',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.SEND.DETAIL': '发送率 = 已发送/用户数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.WATING.DETAIL':
    '排队等待韩国夜间营销时段过去。剩余{time}',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.DELIVERED.DETAIL':
    '送达率 = 送达量/已发送',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.READ.DETAIL': '已读率=已读数/已送达',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.CLICK.DETAIL': '点击率=点击数/已读数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.UNSUBSCRIBE.DETAIL':
    '退订率=退订数/已读数',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.REPLY.DETAIL': '回复率=回复数/已读数',
  // WhatsApp hover文案
  'ACTIVITY.WHATSAPP.LIST.DRAFT.NOTE':
    '活动未创建完成，编辑后可直接发布或申请发布。',
  'ACTIVITY.WHATSAPP.LIST.SCHEDULED.NOTE':
    '活动发布成功，但是未到设置的发送时间，未开始投递。',
  'ACTIVITY.WHATSAPP.LIST.SENDING.ONGOING.NOTE':
    '活动被发布成功，且已经到达设置的发送时间，正常投递中。',
  'ACTIVITY.WHATSAPP.LIST.PAUSED.NOTE':
    '进行中的活动，被手动暂停。当前不再发送消息。',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED.NOTE':
    '进行中的活动，但由于账号限制等问题导致发送被中断。',
  'ACTIVITY.WHATSAPP.LIST.COMPLETED.NOTE': '活动已结束。',
  'ACTIVITY.WHATSAPP.LIST.TERMINATED.NOTE': '活动被手动终止。',
  // hover标题(补充)
  'ACTIVITY.WHATSAPP.LIST.SENDING': '发送中',
  'ACTIVITY.WHATSAPP.LIST.PAUSEDTIP': '已暂停',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED': '发送中断',
};
